import { render, staticRenderFns } from "./TheUpdateStatusSellerRequest.vue?vue&type=template&id=2f3774b5"
import script from "./TheUpdateStatusSellerRequest.vue?vue&type=script&lang=ts"
export * from "./TheUpdateStatusSellerRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports